export default __webpack_public_path__ + "static/media/Touch to talk.8c5e30eb.gif";